import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
      <path
        d='M4.7832 8.39997V6.8833H23.2165V8.39997H4.7832ZM4.7832 21.1166V19.6H23.2165V21.1166H4.7832ZM4.7832 14.7583V13.2416H23.2165V14.7583H4.7832Z'
        fill='#095BBD'
      />
    </svg>
  )
}

export default Icon
